module.exports = __webpack_public_path__ + "static/media/aquaponics.b32fd7ac.jpg";